"use client"

// Subtle ambiance for the creation wizard: keeps the deep black canvas dominant,
// adds a soft brand-blue bloom behind the content for depth, a whisper of film
// grain (so black stays black, never greyed), and an edge vignette to hold the
// corners pure black. Blue is brand.accents.blue (#1d7df2 → rgb(29,125,242)).
//
// Sits at z-0 (NOT negative z): the app shell's bg-background wrapper is an
// opaque black ancestor with no stacking context, so a negative-z layer would
// paint behind it and vanish. At z-0 the fixed layer paints above the page
// background; the wizard content is lifted to z-10 (see create-content), and the
// sidebar/topbar (z-30/z-40) still sit above it. Only mounted on /create.

const GRAIN_SVG =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'>" +
      "<filter id='n'>" +
      "<feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/>" +
      "<feColorMatrix type='saturate' values='0'/>" +
      "</filter>" +
      "<rect width='100%' height='100%' filter='url(#n)'/>" +
      "</svg>"
  )

export function WizardAmbientBackground() {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
      {/* Deep black base — keeps the dark canvas dominant */}
      <div className="absolute inset-0 bg-background" />
      {/* Soft brand-blue bloom behind the content — depth, not a glow */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(56% 46% at 50% 26%, color-mix(in srgb, var(--accent-blue) 16%, transparent), color-mix(in srgb, var(--accent-blue) 5%, transparent) 40%, transparent 70%)",
        }}
      />
      {/* Whisper of film grain — soft-light keeps black black, just adds texture */}
      <div
        className="absolute inset-0 opacity-[0.05] mix-blend-soft-light"
        style={{ backgroundImage: `url("${GRAIN_SVG}")`, backgroundSize: "140px 140px" }}
      />
      {/* Edge vignette — holds the corners pure black */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(120% 110% at 50% 28%, rgba(0,0,0,0) 42%, rgba(0,0,0,0.85) 100%)",
        }}
      />
    </div>
  )
}
